import { Auth0Provider } from "@auth0/auth0-react";
import { auth0Config } from "config";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { initSentry } from "sentry";
import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";

!import.meta.env.DEV && initSentry();

const container = document.getElementById("root")!;
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <Auth0Provider
      {...auth0Config}
      authorizationParams={{
        ...auth0Config.authorizationParams,
        redirect_uri: window.location.origin + "/gettingstarted?theme=colored",
        scope:
          "openid profile email portfolio:read portfolio:write tenant:write tenant:billing profile:read profile:write",
      }}
      cacheLocation="localstorage"
      useRefreshTokens
      useRefreshTokensFallback
    >
      <App />
    </Auth0Provider>
  </BrowserRouter>,
);

console.log("current version:", import.meta.env.VITE_APP_VERSION);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
